const acbcx_comparison = document.querySelector('.acbcx-comparison');
const acbcx_container = document.querySelector('.acbcx-container .page-width');
acbcx_comparison.append(acbcx_container);
const comparison = document.querySelector('.image-comparison');
const comparisonBtn = comparison.querySelector('.image-comparison__button');
let percent = 47.073371805441056;

// Mouse events
comparisonBtn.addEventListener('mousedown', function(event) {
  event.preventDefault();
  startDrag(event.clientX);
});

function startDrag(startX) {
  const onMouseMove = (moveEvent) => {
    const rect = comparison.getBoundingClientRect();
    const offsetX = (moveEvent.clientX || moveEvent.touches[0].clientX) - rect.left;
    percent = Math.min(Math.max((offsetX / rect.width) * 100, 0), 100);
    
    comparison.style.setProperty('--percent', percent + '%');
    comparisonBtn.style.left = percent + '%'; 
  };

  const stopDrag = () => {
    window.removeEventListener('mousemove', onMouseMove);
    window.removeEventListener('mouseup', stopDrag);
    window.removeEventListener('touchmove', onMouseMove);
    window.removeEventListener('touchend', stopDrag);
  };

  window.addEventListener('mousemove', onMouseMove);
  window.addEventListener('mouseup', stopDrag);
  window.addEventListener('touchmove', onMouseMove);
  window.addEventListener('touchend', stopDrag);
}

// Touch events
comparisonBtn.addEventListener('touchstart', function(event) {
  event.preventDefault();
  startDrag(event.touches[0].clientX);
});
